// import router from "@/router";
const ua = navigator.userAgent.toLowerCase();
const isMobileUA =
  /android|iphone|ipad|ipod|blackberry|windows phone|symbianos|webos|opera mini|iemobile/i.test(
    ua
  );
// 2. 辅助检测屏幕宽度（兼容特殊UA）
const isMobileScreen = window.innerWidth <= 1024;
const state = {
  isMobileMode: isMobileUA || isMobileScreen,
};
const getters = {
  isMobileMode: (state) => state.isMobileMode,
};
const mutations = {
  setIsMobileMode(state, isMobileMode) {
    state.isMobileMode = isMobileMode;
  },
};
const actions = {
  setIsMobileMode({ commit }) {
    const ua = navigator.userAgent.toLowerCase();
    const isMobileUA =
      /android|iphone|ipad|ipod|blackberry|windows phone|symbianos|webos|opera mini|iemobile/i.test(
        ua
      );
    // 2. 辅助检测屏幕宽度（兼容特殊UA）
    const isMobileScreen = window.innerWidth <= 1024;
    commit("setIsMobileMode", isMobileUA || isMobileScreen);
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
